import { useContext, createContext } from 'react';

export const MenuContext = createContext<{
  open?: boolean;
  buttonRef?: any;
  floatingStyles: any;
  refs;
  large: boolean;
  portal: boolean;
  fill: boolean;
}>({
  open: false,
  refs: undefined,
  buttonRef: undefined,
  floatingStyles: {},
  portal: false,
  large: false,
  fill: false,
});

export default function useMenuContext() {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error(
      'Menu compound components cannot be rendered outside the Menu component',
    );
  }
  return context;
}
